import React, { useState, useEffect } from "react";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";
import { useModifyEditorialUseOnlyFlag } from "../../hooks/mutations/flags/useModifyEditorialUseOnlyFlag.js";

// components
import { EuoCheckbox as CoreEuoCheckbox } from "frontend/components/fort/mod/core/Sidebar/index.js";

// component
const EuoCheckbox = () => {
    const { addRemoveEUOFlag } = useModifyEditorialUseOnlyFlag();
    const { state } = useQueueContext();
    const { selectedUploads } = state;

    const [showEuo, setShowEuo] = useState(false);
    const [euoIsChecked, setEuoIsChecked] = useState(false);

    const onEuoChange = e => {
        // optimistically alters checkbox - instead of waiting until api
        setEuoIsChecked(e.target.checked);

        // Api update add or remove.
        addRemoveEUOFlag({
            photoUploadIds: selectedUploads.map(u => u.id),
            add: e.target.checked
        });
    };

    useEffect(() => {
        if (selectedUploads.length > 0) {
            const allEuoValues = selectedUploads.map(u => u.editorialUseOnly);
            const allTrue = allEuoValues.every(v => v === true);
            const allFalse = allEuoValues.every(v => v === false);
            const allEqual = allTrue || allFalse;

            setShowEuo(allEqual);
            if (allEqual) {
                setEuoIsChecked(allTrue);
            }
        }
    }, [selectedUploads]);

    if (!showEuo) return null;

    return (
        <CoreEuoCheckbox
            onEuoChange={onEuoChange}
            euoIsChecked={euoIsChecked}
        />
    );
};

export default EuoCheckbox;
